<!--PARTNER AND CUSTOMER TILE-->
<app-card-container
  [title]="'Trusted by Partners and Customers'"
  [description]="'Big, small, simple or complex find your next contact center with Genesys.'"
  [containerBackgroundCss]="!isLightMode ? 'neutral-background' : ''">
  <!--PARTNER AND CUSTOMER TILE CARDS-->
  <app-tile-layout maxColumns="5" class="trusted-row">
    <ng-container *ngFor="let trustedPartner of trustedPartnersData">
      <li>
        <a
          href="{{ trustedPartner?.href }}"
          target="_blank"
          class="image-transform"
          id="{{ trustedPartner?.href }}"
          [attr.data-beyond-id]="trustedPartner?.href"
          (click)="
            sendGoogleAnalytics('Partners and Customers Logo', 'click', trustedPartner?.href)
          "
          ><img
            alt="{{ trustedPartner.alt }}"
            width="{{ trustedPartner.width }}"
            height="{{ trustedPartner.height }}"
            src="{{ trustedPartner.url }}"
        /></a>
      </li>
    </ng-container>
  </app-tile-layout>
  <!--END PARTNER AND CUSTOMER TILE CARDS-->
</app-card-container>
<!--END PARTNER AND CUSTOMER TILE-->
